window.zEmbed || (function () {
    var queue = [];

    window.zESettings = {
        webWidget: {
            position: {horizontal: 'right', vertical: 'bottom'},
            color: {theme: '#1caf9a'},
            zIndex: 100
        }
    };

    window.zEmbed = function () {
        queue.push(arguments);
    };

    window.zE = window.zE || window.zEmbed;
    document.zendeskHost = 'chic.zendesk.com';
    document.zEQueue = queue;

    zE(function () {
        zE.show();
    });
}());
